import i18next from '~/utils/i18n';

const notification = () => ({
    DELETE_USER_SUCCESS : i18next.t('ManageUser.delete_user_success'),
});

export default notification;